// Riesgo del productor (catálogo `niveles_riesgo` de SIC). La vista del mapa
// (`tx_padron_mapas_detalle_search`) devuelve `nivel_riesgo_id` / `nivel_riesgo`
// pero `nivel_riesgo_color` llega null, por eso los colores se resuelven aquí
// por id. Si backend empieza a enviar el color, se respeta el que venga.
const NIVEL_RIESGO_PRODUCTOR = {
  392: { label: 'Alto', color: '#D87748', orden: 1 },
  393: { label: 'Medio', color: '#FFB94C', orden: 2 },
  394: { label: 'Bajo', color: '#BABA04', orden: 3 },
  828: { label: 'Sin Riesgo', color: '#789D16', orden: 4 },
};

const SIN_RIESGO_COLOR = '#C4C4C4';

// Único punto de lectura del riesgo de un productor a partir de una fila de la
// vista de mapas. Si backend cambia nombres de campos, se ajusta solo aquí.
export const getRiesgoProductor = row => {
  const id = row?.nivel_riesgo_id ?? null;
  const known = id != null ? NIVEL_RIESGO_PRODUCTOR[id] : null;
  return {
    id,
    label: row?.nivel_riesgo || known?.label || null,
    color: row?.nivel_riesgo_color || known?.color || SIN_RIESGO_COLOR,
    // Mayor severidad primero; sin dato al final.
    orden: known?.orden ?? 99,
  };
};

export default NIVEL_RIESGO_PRODUCTOR;
